import React from 'react';
import PropTypes from 'prop-types';

const InvoiceCountSelector = ({
  invoiceCount,
  onInvoiceCountChange,
  onResetLineItems,
  resetLineItemId = 3030,
  className = '',
  style = {},
  invoiceCountOptions
}) => {
  const handleCountChange = (e) => {
    const newCount = parseInt(e.target.value);
    if (newCount !== parseInt(invoiceCount)) {
      const confirmReset = window.confirm("Changing invoice count will reset your existing data. Are you sure?");
      if (confirmReset) {
        onInvoiceCountChange(newCount);
        if (onResetLineItems) {
          onResetLineItems(resetLineItemId);
        }
      }
    }
  };

  return (
    <div className={`col-md-2 ${className}`} style={{ display: 'inline-flex', ...style }}>
      <span style={{ marginRight: '6px' }}># Invoices?</span>
      <select 
        style={{ width: "45px", height: "26px" }}
        value={invoiceCount}
        onChange={handleCountChange}
      >
        {invoiceCountOptions.map((num) => (
          <option key={num} value={num}>
            {num}
          </option>
        ))}
      </select>
    </div>
  );
};

InvoiceCountSelector.propTypes = {
  invoiceCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onInvoiceCountChange: PropTypes.func.isRequired,
  onResetLineItems: PropTypes.func,
  resetLineItemId: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
};

export default InvoiceCountSelector;